import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'
import localforage from 'localforage';

const useAppStore = create()(
  devtools(
    persist(
      (set) => ({
        token: "",
        user: null,
        users: [],
        counties: [],
        authorities: [],
        aggregatedWorkload: [],
        setToken: (newToken) => set(() => ({ token: newToken })),
        setUser: (newUser) => set(() => ({ user: newUser })),
        setUsers: (newUsers) => set(() => ({ users: newUsers })),
        setCounties: (newCounties) => set(() => ({ counties: newCounties })),
        setAuthorities: (newAuthorities) => set(() => ({ authorities: newAuthorities })),
        setAggregatedWorkload: (newWorkload) => set(() => ({ aggregatedWorkload: newWorkload })),
      }),
      {
        name: 'nphl-dash-storage',
        storage: createJSONStorage(() => localforage),
      },
    ),
  ),
)
export default useAppStore;
